import { render, staticRenderFns } from "./ReporteBcraPage.vue?vue&type=template&id=476b48a8&scoped=true"
import script from "./ReporteBcraPage.vue?vue&type=script&lang=js"
export * from "./ReporteBcraPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b48a8",
  null
  
)

export default component.exports